__turbopack_context__.v({
  "admin-bg-danger": "Services-module-scss-module__Nut0xG__admin-bg-danger",
  "admin-bg-info": "Services-module-scss-module__Nut0xG__admin-bg-info",
  "admin-bg-primary": "Services-module-scss-module__Nut0xG__admin-bg-primary",
  "admin-bg-secondary": "Services-module-scss-module__Nut0xG__admin-bg-secondary",
  "admin-bg-success": "Services-module-scss-module__Nut0xG__admin-bg-success",
  "admin-bg-warning": "Services-module-scss-module__Nut0xG__admin-bg-warning",
  "admin-border": "Services-module-scss-module__Nut0xG__admin-border",
  "admin-border-dark": "Services-module-scss-module__Nut0xG__admin-border-dark",
  "admin-border-light": "Services-module-scss-module__Nut0xG__admin-border-light",
  "admin-rounded": "Services-module-scss-module__Nut0xG__admin-rounded",
  "admin-rounded-full": "Services-module-scss-module__Nut0xG__admin-rounded-full",
  "admin-rounded-lg": "Services-module-scss-module__Nut0xG__admin-rounded-lg",
  "admin-rounded-md": "Services-module-scss-module__Nut0xG__admin-rounded-md",
  "admin-rounded-sm": "Services-module-scss-module__Nut0xG__admin-rounded-sm",
  "admin-shadow-lg": "Services-module-scss-module__Nut0xG__admin-shadow-lg",
  "admin-shadow-md": "Services-module-scss-module__Nut0xG__admin-shadow-md",
  "admin-shadow-sm": "Services-module-scss-module__Nut0xG__admin-shadow-sm",
  "admin-sr-only": "Services-module-scss-module__Nut0xG__admin-sr-only",
  "admin-text-light": "Services-module-scss-module__Nut0xG__admin-text-light",
  "admin-text-muted": "Services-module-scss-module__Nut0xG__admin-text-muted",
  "admin-text-primary": "Services-module-scss-module__Nut0xG__admin-text-primary",
  "admin-text-secondary": "Services-module-scss-module__Nut0xG__admin-text-secondary",
  "services__container": "Services-module-scss-module__Nut0xG__services__container",
  "services__container--no-bottom": "Services-module-scss-module__Nut0xG__services__container--no-bottom",
  "services__container--no-top": "Services-module-scss-module__Nut0xG__services__container--no-top",
  "services__container--no-vertical": "Services-module-scss-module__Nut0xG__services__container--no-vertical",
  "services__container--reverse": "Services-module-scss-module__Nut0xG__services__container--reverse",
  "services__content": "Services-module-scss-module__Nut0xG__services__content",
  "services__gallery": "Services-module-scss-module__Nut0xG__services__gallery",
  "services__gallery-image": "Services-module-scss-module__Nut0xG__services__gallery-image",
  "services__gallery-image--active": "Services-module-scss-module__Nut0xG__services__gallery-image--active",
  "services__list": "Services-module-scss-module__Nut0xG__services__list",
  "services__list--item": "Services-module-scss-module__Nut0xG__services__list--item",
  "services__list--item-description": "Services-module-scss-module__Nut0xG__services__list--item-description",
  "services__list--item-title": "Services-module-scss-module__Nut0xG__services__list--item-title",
  "services__media-wrapper": "Services-module-scss-module__Nut0xG__services__media-wrapper",
  "services__media-wrapper--gallery": "Services-module-scss-module__Nut0xG__services__media-wrapper--gallery",
  "services__title": "Services-module-scss-module__Nut0xG__services__title",
  "services__vimeo-wrapper": "Services-module-scss-module__Nut0xG__services__vimeo-wrapper",
});
